import { getAdditionalUserInfo, UserCredential } from "firebase/auth";

import { signInWithProvider } from "services/firebase/auth";
import { ProviderSSO } from "services/firebase/auth/types";

import { FirebaseUserInfo } from "features/user/actions/auth/sso/types";

export default async function authenticateWithSSO({
  providerName,
  signInWithRedirect
}: {
  providerName: ProviderSSO;
  signInWithRedirect?: boolean;
}) {
  const userCredential = (await signInWithProvider(
    providerName,
    signInWithRedirect
  )) as UserCredential;
  const additionalUserInfo = getAdditionalUserInfo(userCredential);

  return {
    userCredential,
    userProfile: additionalUserInfo?.profile as
      | FirebaseUserInfo["profile"]
      | undefined,
    isNewUser: !!additionalUserInfo?.isNewUser
  };
}
